import React from 'react';

import { Button, InlineLoader } from '@jutro/components';

function renderLoader(isLoading) {
    return isLoading ? <InlineLoader loading={isLoading} className="gw-inline-loader" /> : null;
}

const ButtonWithLoader = (props) => {
    const {
        onClick, disabled, label, isLoading, className, type, id
    } = props;

    return (
        <Button
            id={id}
            onClick={onClick}
            disabled={disabled}
            className={className}
            type={type}
        >
            {label}
            {renderLoader(isLoading)}
        </Button>
    );
};

export default ButtonWithLoader;
